export default import.meta.ROLLDOWN_FILE_URL_DzYsnjr1LtW1tBWqsYm2RQ